export class PosWs {
  _connection = null;
  _messageHandlers = [];
  _errorHandlers = [];
  _closeHandlers = [];
  _openHandlers = [];

  _timeoutController = null;
  _url = null;
  _timeout = null;
  _delayedSend = [];

  constructor({
    onOpen = null,
    onMessage = null,
    onError = null,
    onClose = null,
  } = {}) {
    this._messageHandlers.push(onMessage);
    this._openHandlers.push(onOpen);
    this._errorHandlers.push(onError);
    this._closeHandlers.push(onClose);
  }

  _responseWaiters = {};

  open(url, timeout = null) {
    console.log(url);
    this._url = url;
    this._timeout = timeout;
    this._connection = new WebSocket(this._url);

    if (timeout) {
      this._timeoutController = setTimeout(() => {
        this._connection.close();
      }, timeout);
    }

    this.assignListeners();
  }

  assignListeners() {
    this._connection.addEventListener("open", this.handleOpen.bind(this));
    this._connection.addEventListener("message", this.handleMassage.bind(this));
    this._connection.addEventListener("close", this.handleClose.bind(this));
    this._connection.addEventListener("error", this.handleError.bind(this));
  }

  handleOpen() {
    if (this._timeoutController) {
      clearTimeout(this._timeoutController);
    }

    this._openHandlers.forEach((handler) => handler?.());

    this._delayedSend.forEach((message) => this.send(message));
    this._delayedSend = [];
  }

  handleClose(closeEvent) {
    console.log(closeEvent);
    this._closeHandlers.forEach((handler) => handler?.(closeEvent));
  }

  handleError(errorEvent) {
    this._errorHandlers.forEach((handler) => handler?.(errorEvent));
  }

  reconnect(url = null) {
    this.open(url || this._url, this._timeout);
  }

  sendSync(messageData) {
    const _correlationId = crypto.randomUUID();
    messageData["correlation_id"] = _correlationId;

    this.send(messageData);

    return new Promise((resolve) => {
      this._responseWaiters[_correlationId] = { resolve };
    });
  }

  send(messageData) {
    if (this._connection.readyState !== 1) {
      this._delayedSend.push(messageData);

      if ([3, 4].includes(this._connection.readyState)) {
        this.reconnect();
      }

      return;
    }

    console.log("sending message:", messageData);
    this._connection.send(JSON.stringify(messageData));
  }

  onMessage(callback) {
    this._messageHandlers.push(callback);
  }

  onError(callback) {
    this._errorHandlers.push(callback);
  }

  async handleMassage(wsMessage) {
    const _messageData = JSON.parse(wsMessage.data);
    console.log("received message", _messageData);

    if (
      _messageData.correlation_id &&
      this._responseWaiters[_messageData.correlation_id]
    ) {
      this._responseWaiters[_messageData.correlation_id]?.resolve?.(
        _messageData
      );
    } else {
      this._messageHandlers.forEach((handler) => {
        handler?.(_messageData);
      });
    }
  }
}
